@app.service 'matrixItemService', ->

  @isRecipe = (activityType) ->
    activityType?.indexOf('Technique') == -1 && activityType?.indexOf('Recipe') > -1

  this
